import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { useAppNavigation } from "@/hooks/use-app-navigation";

export function NotFoundPage() {
    const { t } = useTranslation();

    const { navigateBack } = useAppNavigation();

    return (
        <div className="flex flex-col items-center justify-center h-full gap-4">
            <h2 className="text-4xl font-bold text-primary">{t("404_title")}</h2>
            <p className="text-muted-foreground">{t("not_found_message")}</p>

            <Button variant="default" className="mt-4" size="lg" onClick={navigateBack}>
                {t("go_back")}
            </Button>
        </div>
    );
}

export const Route = createFileRoute("/NotFound/")({
    component: NotFoundPage,
});
